module.exports = __webpack_public_path__ + "static/media/20170501-DSC02537-5_Small.68fcb255.jpg";